import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { getRecentHistoryList } from 'dibs-recent-history/exports/getRecentHistory';

import { HomePageContext } from '../HomePageContext';
import { connectContext } from '../../context/helpers/connectContext';
import { HpRespRecentlyViewedItemsCarousel } from './HpRespRecentlyViewedItemsCarousel';
import { HpSharedModuleContainer } from '../HpSharedModuleContainer/HpSharedModuleContainer';

const MOBILE_ITEMS_PER_PAGE = 2.5;
const TABLET_ITEMS_PER_PAGE = 4;
const DESKTOP_ITEMS_PER_PAGE = 6;

class HpRespRecentlyViewedItemsComponent extends Component {
    state = {
        render: false,
    };

    componentDidMount() {
        this.handleItemsRender();
    }

    componentDidUpdate() {
        this.handleItemsRender();
    }

    handleItemsRender() {
        const itemsPerPage = this.getItemsPerPage();
        const recentHistoryItems = get(this.props, 'user.recentHistoryList');
        const items = getRecentHistoryList({ recentHistoryItems, isClient: true });
        const recentHistoryCount = items && items.length;
        const isFullPage = recentHistoryCount >= Math.ceil(itemsPerPage);

        if (isFullPage && !this.state.render) {
            this.setState({ render: true });
        }
    }

    getItemsPerPage() {
        const { isMobile, isTablet } = this.props;

        if (isMobile) {
            return MOBILE_ITEMS_PER_PAGE;
        } else if (isTablet) {
            return TABLET_ITEMS_PER_PAGE;
        }

        return DESKTOP_ITEMS_PER_PAGE;
    }

    render() {
        const recentHistoryItems = get(this.props, 'user.recentHistoryList');
        const items = getRecentHistoryList({ recentHistoryItems, isClient: true });
        const itemsPerPage = this.getItemsPerPage();
        const { render } = this.state;

        return (
            render && (
                <HpSharedModuleContainer>
                    <HpSharedModuleContainer.Header>
                        <FormattedMessage
                            id="homepage.modules.recentlyViewed.title"
                            defaultMessage="Recently Viewed"
                        />
                    </HpSharedModuleContainer.Header>
                    <HpRespRecentlyViewedItemsCarousel items={items} itemsPerPage={itemsPerPage} />
                </HpSharedModuleContainer>
            )
        );
    }
}

HpRespRecentlyViewedItemsComponent.propTypes = {
    user: PropTypes.object,
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
};

function mapContextToProps({ isMobile, isTablet }) {
    return { isMobile, isTablet };
}

export const HpRespRecentlyViewedItems = createFragmentContainer(
    connectContext(HomePageContext, mapContextToProps)(HpRespRecentlyViewedItemsComponent),
    {
        user: graphql`
            fragment HpRespRecentlyViewedItems_user on User {
                ...getRecentHistory_user @relay(mask: false)
            }
        `,
    }
);
